import React from "react";

const BookingPageFormSkeleton = ({
  showToggle = false,
  showFileUpload = false,
  inputCount = 3,
  showEnhancedSection = false,
}) => {
  return (
    <div className="px-4 py-6 sm:p-8">
      <div className="animate-pulse">
        {/* Toggle Section Skeleton */}
        {showToggle && (
          <div className="mb-6 pb-6 border-b border-ink-100">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-6 bg-cream-300 rounded-full"></div>
                <div className="h-4 bg-cream-300 rounded w-64"></div>
              </div>
            </div>
          </div>
        )}

        {/* File Upload Skeleton */}
        {showFileUpload && (
          <div className="mb-6">
            <div className="h-4 bg-cream-300 rounded w-24 mb-3"></div>
            <div className="flex items-center space-x-4">
              <div className="w-20 h-20 bg-cream-300 rounded-lg"></div>
              <div className="flex-1">
                <div className="h-4 bg-cream-300 rounded w-32 mb-2"></div>
                <div className="h-3 bg-cream-300 rounded w-48"></div>
              </div>
            </div>
          </div>
        )}

        {/* Input Fields Skeleton */}
        <div className="space-y-6">
          {Array.from({ length: inputCount }).map((_, index) => (
            <div key={index}>
              <div className="h-4 bg-cream-300 rounded w-20 mb-2"></div>
              <div className="h-10 bg-cream-300 rounded w-full"></div>
            </div>
          ))}
        </div>

        {/* Enhanced Section Skeleton (for BookingPageForm) */}
        {showEnhancedSection && (
          <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-accent-200 rounded-lg">
            <div className="h-4 bg-cream-300 rounded w-32 mb-3"></div>
            <div className="flex items-center space-x-3 mb-3">
              <div className="h-8 bg-cream-300 rounded w-64"></div>
              <div className="w-6 h-6 bg-cream-300 rounded"></div>
            </div>
            <div className="h-8 bg-cream-300 rounded w-16"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingPageFormSkeleton;
